var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"backTop"},[_c('div',{staticClass:"backTop_list",class:{ active: _vm.isShow }},[_c('p',{staticClass:"backTop-item top",on:{"click":_vm.backTop}},[_c('img',{attrs:{"src":_vm.imgUrl + 'icon-top.png'}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }